<script>
    export let data = {}

    const { content } = data
</script>

<div class="modal-content">
    {@html content}
</div>
